<template>
      <!-- src="https://via.placeholder.com/500" height="300" -->
  <article 
    :class="(!fullscreen && type != 'mini') ? `fixed fixed-${type}` : 'full'">
    <figure
      v-if="type === 'image'"
      class="set-ratio"
      :class="type"
      :style="{backgroundImage : `url('${imageUrl}')`}">
    </figure>
    <p 
      v-else
      v-html="text">{{text}}</p>
  </article>
</template>

<script>
export default {
  name: "screen",
  props: {
    fullscreen: Boolean,
    text: String,
    type: String,
    imageUrl: String
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/_mixins.scss';

article {
  position: relative;
  text-align: justify;
  margin: $default_vmin 0;
  padding: 0 $default_vmin;
      // position: relative; // fallback for browsers not supporting sticky position
      // position: sticky;
      // top: 0.75em;
      // transform-origin: center top;

  &:not(.fixed) {
    background: $gray_light_4;
    
    @include respond-to(desktop) {
      padding: $default_vmin 0;
    }
  }

  &.fixed {
    padding: 0 $default_vmin;
  }

  figure {
    &.set-ratio {
      @include ratio(6,2);
      @include bgImage(cover);

    }
  }

  p {
    @include respond-to(desktop) {
      text-align: center;
      line-height: 1.8;
      padding: $large_vmin;
    }

    @include respond-to(tv) {
      text-align: justify;
      column-count: 2;
      column-gap: $default_vmin;
    }
  }
}
</style>


